import { render, staticRenderFns } from "./ResellerNewReqList.vue?vue&type=template&id=4c1076be"
import script from "./ResellerNewReqList.vue?vue&type=script&lang=js"
export * from "./ResellerNewReqList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports